import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { SimpleDropdown } from '@/components/ui/simple-dropdown';
import { AILocationHintsEditor } from './AILocationHintsEditor';
import type { AnswerOptionCondition } from 'shared/types/due-diligence';

interface AIQuestionEditorProps {
  condition: AnswerOptionCondition;
  onUpdate: (updates: Partial<AnswerOptionCondition>) => void;
}

export function AIQuestionEditor({ condition, onUpdate }: AIQuestionEditorProps) {
  const answerOptions = [
    { value: 'yes', label: 'Ja' },
    { value: 'no', label: 'Nee' },
  ];

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label className="text-sm font-medium">AI Vraag</Label>
        <Input
          placeholder="bijv. Is dit document ondertekend?"
          value={condition.aiQuestion || ''}
          onChange={(e) => onUpdate({ aiQuestion: e.target.value })}
          className="text-sm"
        />
        <p className="text-xs text-muted-foreground">
          Stel een ja/nee vraag die AI kan beantwoorden door het document te analyseren.
        </p>
      </div>
      <div className="space-y-2">
        <Label className="text-sm font-medium">Verwacht antwoord</Label>
        <SimpleDropdown
          value={condition.expectedAnswer || 'yes'}
          onChange={(value) => onUpdate({ expectedAnswer: value as 'yes' | 'no' })}
          options={answerOptions}
          placeholder="Selecteer verwacht antwoord..."
        />
      </div>
      <AILocationHintsEditor condition={condition} onUpdate={onUpdate} />
    </div>
  );
}
